import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const WHATSAPP_NUMBER = '905322705174';
const DEFAULT_MESSAGE = 'Merhaba, web sitenizden ulaşıyorum. Bilgi almak istiyorum.';

export const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[9999]" style={{ pointerEvents: 'auto' }}>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            className="absolute bottom-16 right-0 w-72 bg-slate-900 border border-slate-700 rounded-lg shadow-2xl overflow-hidden mb-2"
          >
            {/* Header */}
            <div className="bg-[#25D366] p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm">ELC Teknoloji</h4>
                  <p className="text-white/80 text-xs">Genellikle birkaç dakika içinde yanıt verir</p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="p-4 bg-[#0B141A]">
              <div className="bg-slate-800 rounded-lg p-3 relative">
                <p className="text-slate-300 text-sm">
                  Merhaba! 👋 Size nasıl yardımcı olabiliriz? Siber güvenlik çözümleri, Zebra ürünleri veya diğer konularda sorularınızı bekliyoruz.
                </p>
                <span className="text-[10px] text-slate-500 absolute bottom-1 right-3">şimdi</span>
              </div>
            </div>

            {/* Footer */}
            <div className="p-3 bg-slate-900 border-t border-slate-800">
              <button
                onClick={handleClick}
                aria-label="WhatsApp sohbeti başlat"
                className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                Sohbeti Başlat
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Button */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'WhatsApp penceresini kapat' : "WhatsApp ile iletişime geç"}
        className={`relative flex items-center gap-2 h-14 px-5 rounded-full shadow-lg transition-colors cursor-pointer ${
          isOpen ? 'bg-slate-700' : 'bg-[#25D366] hover:bg-[#20BD5A]'
        }`}
        style={{ pointerEvents: 'auto' }}
        data-testid="whatsapp-button"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current shrink-0">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        )}
        <span className="text-white font-semibold text-base whitespace-nowrap">
          {isOpen ? 'Kapat' : 'WhatsApp'}
        </span>
      </motion.button>

      {/* Pulse animation */}
      {!isOpen && (
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 pointer-events-none"></span>
      )}
    </div>
  );
};

export default WhatsAppButton;
